import React, { Component } from 'react';
import { Route, Redirect, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import { validateToken } from '../_actions';

class PrivateRouteComponent extends Component {

  componentDidMount() {
    this.checkAccess();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.pathname !== this.props.location.pathname) {
      this.checkAccess();
    }
  }

  checkAccess = () => {
    if (this.props.auth.user) {
      this.props.validateToken(this.props.auth.user.token);
    }
  };

  render() {
    const { component: Component, ...rest } = this.props;
    const { user, validToken, sessionExpired } = this.props.auth;

    return (
      <Route
        {...rest}
        render={props => {
            if (user && validToken) {
            return <Component {...props} />;
            }
            const redirectTo = sessionExpired ? '/login' : '/membership';
            return <Redirect to={{ pathname: redirectTo, state: { from: props.location } }} />;
        }}
      />
    );
  }
}

const mapStateToProps = state => ({ auth: state.authentication });
const mapDispatchToProps = dispatch => bindActionCreators({ validateToken }, dispatch);

const ConnectedPrivateRoute = compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(PrivateRouteComponent);

export { ConnectedPrivateRoute as PrivateRoute };